'use client';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';

declare global {
  interface Window {
    Telegram: {
      WebApp: any;
    };
  }
}

export default function TelegramAuth() {
  const router = useRouter();
  const [debug, setDebug] = useState('');

  // 🔴 ДОБАВИЛ: функция для ручного перехода
//  const manualRedirect = () => {
//    return;
//    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  //  const tg = window.Telegram?.WebApp;
  //  const user = tg?.initDataUnsafe?.user;

//    if (user && !isMobile) {
      // 🔴 ИСПРАВЛЕНО: используем Telegram метод для открытия ссылки
  //    if (window.Telegram?.WebApp?.openLink) {
    //    window.Telegram.WebApp.openLink(`https://meet.lanloop.site/account/student?uid=${user.id}&auth=1&1`);
//      } else {
        // Fallback для обычного браузера
  //      window.open(`https://meet.lanloop.site/account/student?uid=${user.id}&auth=1&2`, '_blank');
    //  }
//    } else {
  //    window.location.href = '/account/student';
//    }
//  };

  useEffect(() => {
    const initTelegram = () => {
      if (window.Telegram && window.Telegram.WebApp) {
        setDebug('Telegram WebApp ready');
        const tg = window.Telegram.WebApp;
        tg.expand();

        const user = tg.initDataUnsafe?.user;
        if (user) {
          setDebug(`User: ${user.first_name}, authorizing...`);

          fetch('/api/auth/telegram', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              telegramId: user.id,
              username: user.username,
              displayName: user.first_name + (user.last_name ? ' ' + user.last_name : ''),
              name: user.first_name
            })
          })

          .then(response => response.json())
          .then(data => {
            if (data.success) {
              const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

              if (isMobile) {
                // 🔴 МОБИЛЬНЫЕ: автоматически в ЛК Web App
                setDebug('Mobile - redirecting to ${data.redirect}...');
                window.location.href = `${data.redirect}?uid=${data.user.id}&auth=1`;
              } else {
                // 🔴 КОМПЬЮТЕРЫ: показываем кнопку (но по твоему требованию - тоже автоматически)
                setDebug('Computer - redirecting to ${data.redirect}...');
                window.location.href = `${data.redirect}?uid=${data.user.id}&auth=1`;
              }
              //  setDebug('Computer - opening browser...');
              //  const browserUrl = `https://meet.lanloop.site/account/student?uid=${user.id}&auth=1`;
              //  if (window.Telegram?.WebApp?.openLink) {
                  // 🔴 ДОБАВИЛ: принудительный вызов через timeout
              //    setTimeout(() => {
              //      window.Telegram.WebApp.openLink(browserUrl);
              //    }, 1000);
              //  }
              //} else {
              //  setDebug('Mobile - redirecting...');
              //  window.location.href = '/account/student';
              //}
              setDebug(`Авторизован! Роль: ${data.user.role}. Нажмите кнопку ниже.`);
            }
          })
          .catch(error => {
            setDebug(`Error: ${error.message}. Use manual button.`);
          });
        }
      } else {
        setDebug('Loading Telegram WebApp...');
        const script = document.createElement('script');
        script.src = 'https://telegram.org/js/telegram-web-app.js';
        script.onload = () => {
          setTimeout(() => {
            if (window.Telegram && window.Telegram.WebApp) {
              initTelegram();
            }
          }, 1000);
        };
        document.head.appendChild(script);
      }
    };

    initTelegram();
  }, [router]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
        <p className="mt-4 text-gray-600">Авторизация через Telegram...</p>
       {/* <p className="mt-2 text-sm text-gray-400">{debug}</p> */}

      </div>
    </div>
  );
}
